import React, { HTMLAttributes, forwardRef } from 'react'
import theme from 'presentation/styles/theme'
import * as S from './style'
import HeadingNew from 'presentation/shared/components/HeadingNew'
import SupportTextNew from 'presentation/shared/components/SupportTextNew'

export type CardProps = {
  text: string | React.ReactElement
  countValue?: number | string | undefined
  icon?: React.ReactElement
  style?: React.CSSProperties
  shadow?: keyof typeof theme.ds.shadows
  radius?: keyof typeof theme.ds.typography.border.radius
  padding?: string
  color?: keyof typeof theme.ds.colors
  countValueColor?: keyof typeof theme.ds.colors
  iconColor?: keyof typeof theme.ds.colors
  bgColor?: keyof typeof theme.ds.colors
  disabled?: boolean
  onClick?: () => void
  ref?: any
} & HTMLAttributes<HTMLDivElement>

const CardCounter = forwardRef(
  (
    {
      text,
      countValue,
      icon,
      style,
      shadow,
      radius,
      color = 'neutral700',
      countValueColor = 'neutral700',
      iconColor = 'neutral700',
      bgColor,
      padding,
      disabled,
      onClick,
      ...props
    }: CardProps,
    ref
  ) => {
    return (
      <S.CardWrapper
        style={style}
        shadow={shadow}
        radius={radius}
        bgColor={bgColor}
        padding={padding}
        disabled={disabled}
        onClick={onClick}
        ref={ref}
        {...props}
      >
        {icon && (
          <>
            <S.IconWrapper iconColor={iconColor}>{icon}</S.IconWrapper>
          </>
        )}
        {typeof text !== 'string' ? (
          text
        ) : (
          <HeadingNew
            as="h3"
            size="xsmall"
            color={color}
            weight="semiBold"
            style={{
              marginLeft: 0,
              marginRight: 'auto',
              width: '100%',
              maxWidth: '200px'
            }}
          >
            {text}
          </HeadingNew>
        )}

        <SupportTextNew
          color={countValueColor ?? color}
          size="xxlarge"
          weight="bold"
          style={{ marginRight: 0 }}
        >
          {countValue}
        </SupportTextNew>
      </S.CardWrapper>
    )
  }
)

CardCounter.displayName = 'CardCounter'
export default CardCounter
